import React, { Fragment } from "react";
import { Card } from "luna-react/components/card";
import { PrimaryButton } from "luna-react/components/button";
import { Grid } from "luna-react/components/grid";
import { sections } from "../../config";
import SectionCard from "../common/SectionCard";
import { marketingPermissionsUrl } from "../../config";

import "./scss/Home.scss";

const Home = () => {
  return (
    <Fragment>
      <Card className="home__wrapper">
        <h1 className="center-text">Sainsbury's Group Privacy Hub</h1>
        <hr />
        <h6>The Privacy Hub</h6>
        <p>
          Welcome to the Privacy Hub &mdash; home to everything you need to know
          about your data and how we keep it safe. Find out how we collect your
          personal data and what rights you have over it too.
        </p>
        <Grid.Wrapper verticalAlign="middle">
          <Grid.Item size="1">
            <div className="brands__wrapper">
              <Grid.Wrapper horizontalAlign="center">
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--sainsburys" />
                </Grid.Item>
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--argos" />
                </Grid.Item>
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--habitat" />
                </Grid.Item>
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--tu" />
                </Grid.Item>
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--sainsburys_bank" />
                </Grid.Item>
                <Grid.Item size={{ sm: "1/3", md: "1/6", xs: "1/2" }}>
                  <div className="brand_logo brand_logo--nectar" />
                </Grid.Item>
                <Grid.Item size="1">
                  <h6 className="center-text">
                    View Sainsbury’s Bank information{" "}
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.sainsburysbank.co.uk/legals/leg-reg-privacy-policy"
                    >
                      here
                    </a>
                  </h6>
                  <h6 className="center-text">
                    View Nectar’s information{" "}
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.nectar.com/about/privacy-and-legal"
                    >
                      here
                    </a>
                  </h6>
                  <h6 className="center-text">
                    View Facial Recognition Technology privacy information{" "}
                    <a href="/privacy-policy/#facial-recognition-technology">
                      here
                    </a>
                  </h6>
                </Grid.Item>
              </Grid.Wrapper>
            </div>
          </Grid.Item>
          <Grid.Item className="marketing_permissions__wrapper" size="1">
            <hr />
            <Grid.Item
              className="marketing_permissions_text center-text"
              size={{ sm: "3/5" }}
            >
              Manage your marketing permissions across Sainsbury's Group
            </Grid.Item>
            <Grid.Item
              className="marketing_permissions_button center-text"
              size={{ sm: "2/5" }}
            >
              <a
                rel="noopener noreferrer"
                target="_blank"
                href={marketingPermissionsUrl}
              >
                <PrimaryButton>
                  Manage Group marketing permissions
                </PrimaryButton>
              </a>
            </Grid.Item>
          </Grid.Item>
        </Grid.Wrapper>
      </Card>
      <Grid.Wrapper
        className="section__wrapper"
        matrix
        horizontalAlign="center"
      >
        {sections.map((section, item) => (
          <Grid.Item key={item} size={{ sm: "1/2", md: "1/3" }}>
            <SectionCard section={section} className="section_card" />
          </Grid.Item>
        ))}
      </Grid.Wrapper>
      <Card>
        <Grid.Item size="1">
          <h4>How to contact us</h4>
          <p>
            If you have a data related query or complaint, you can contact us
            through the following methods
          </p>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:privacy@sainsburys.co.uk">
              privacy@sainsburys.co.uk
            </a>
          </p>
          <p>
            <strong>Letter:</strong> Privacy Team, Sainsbury's Supermarkets Ltd,
            18th Floor, Arndale House, Manchester, M4 3AL
          </p>
          <p>
            <strong>Telephone:</strong>{" "}
            <a href="tel:0800636262">0800 63 62 62</a>
          </p>
        </Grid.Item>
      </Card>
    </Fragment>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/pages/Home.js